"use client";

import React from "react";
import { BdAltArrowLeft } from "solar-icon-react/bd";
import { cn } from "@/lib";
import Link from "next/link";

interface IChild {
  id: number;
  key: string;
  label: string;
  href: string;
}

interface IData {
  key: string | number;
  title: string;
  icon: any;
  href: string;
  iconClassName: string;
  children: IChild[];
}

interface IProps {
  data: IData;
}

// A single arrow element we can clone per row — same pattern as CoreServicesSection

export default function BillsIntroCard({ data }: IProps) {
  return (
    <div
      className="relative w-full overflow-hidden rounded-3xl sm:max-w-[400px]"
      style={{ backgroundColor: "#5b5bd6" }}
    >
      {/* ── Header ── */}
      <div className="overflow-hidden px-5 pt-6 pb-6">
        <Link href={data.href}>
          <div
            className={cn(
              "absolute top-2 left-2 z-10 flex items-center justify-center text-white opacity-20",
              data.iconClassName,
            )}
          >
            {data.icon}
          </div>

          <h2 className="w-full text-right text-lg leading-snug font-bold text-wrap text-white lg:text-xl xl:text-2xl">
            {data.title}
          </h2>
        </Link>
      </div>
      {/* ── Rows ── */}
      <div>
        {data.children.map((item, index) => (
          <div key={item.id}>
            <Link
              href={item.href}
              className="flex w-full cursor-pointer items-center gap-2 p-2 transition-colors duration-150 hover:bg-white/10 active:bg-white/15 lg:gap-3 lg:px-4 lg:py-3.5"
            >
              <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full p-1.5 text-white">
                {data.icon}
              </span>

              <span
                className="flex-1 text-right font-semibold text-white"
                style={{ fontSize: "0.9rem" }}
              >
                {item.label}
              </span>
              <BdAltArrowLeft className="text-white" />
            </Link>
            {index !== data.children.length - 1 && (
              <div
                style={{
                  borderBottom: "1.5px dashed rgba(255,255,255,0.35)",
                  marginLeft: "16px",
                  marginRight: "16px",
                }}
              />
            )}
          </div>
        ))}
      </div>

      <div className="h-4" />
    </div>
  );
}
